import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DispositionsComponent } from './dispositions.component';
import { MatTableModule } from '@angular/material/table';
import { SharedModule } from '../components/shared.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [DispositionsComponent],
  imports: [CommonModule, MatTableModule, SharedModule, MatButtonModule],
  exports: [DispositionsComponent],
})
export class DispositionsModule {}
